import { extend, $, $$, hasParentsClass } from './helper-functions'

export class SelectLanguage {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      button: '.button--select-language'
    }, selectors)

    this.classes = extend({
      active: 'select-language--active',
      block: 'select-language',
      button: 'button--select-language'
    }, classes)
  }

  init () {
    this.$selectLanguageButtons = $$(this.selectors.button)
    this.events()
  }

  events () {
    this.$selectLanguageButtons.forEach((selectLanguageButton) => {
      selectLanguageButton.addEventListener('click', () => {
        if (selectLanguageButton.classList.contains(this.classes.active)) {
          selectLanguageButton.classList.remove(this.classes.active)
        } else {
          selectLanguageButton.classList.add(this.classes.active)
        }
      })
    })

    $('body').addEventListener('click', (event) => {
      if (!hasParentsClass(event.target, this.classes.block) && !hasParentsClass(event.target, this.classes.button)) {
        this.$selectLanguageButtons.forEach((selectLanguageButton) => {
          selectLanguageButton.classList.remove(this.classes.active)
        })
      }
    })

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.$selectLanguageButtons.forEach((selectLanguageButton) => {
          selectLanguageButton.classList.remove(this.classes.active)
        })
      }
    })
  }
}

export default SelectLanguage
